import * as FormControl from '../utils/form-controls';
import * as CONST from '../utils/constants';

// global window
const filterObj = CONST.globalProject.ResourceFilters;

// initial state
// object name must match specification name
const filters = {
	ResourceType: new FormControl.FilterGroup('ResourceType', 'Filter by Type', 'All Types', '', false, true, 'checkbox')
};

FormControl.assignFilters(filterObj, filters);

export { filters as default };